import Links from "../../components/elements/Links";
import Message from "../../components/Message";
import Button from "../../components/elements/Button";
import Title2 from "../../components/elements/Title2";
import { motion } from "framer-motion";
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { uploads } from "../../utils/config";
import { profile, resetMessage, updateProfile } from "../../slices/userSlice";

const EditProfile = () => {
  
  const dispatch = useDispatch();
  const { user, message, error, loading } = useSelector((state) => state.user);
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);
  const [showMessageError, setShowMessageError] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [name, setName] = useState("");
  const [nickname, setNickname] = useState("");
  const [orientation, setOrientation] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const toggleVisibility = () => {
    if(!error){
      setShowMessageSuccess(true);
    }
  }

  useEffect(() => {
    dispatch(profile());
  }, [dispatch]);

  useEffect(() => {
    if(user) {
      setName(user.name);
      setNickname(user.nickname);
      setOrientation(user.orientation);
      setProfileImage(user.profileImage);
    }
  }, [user]);

  const handleSubmit = async (e) => {

    e.preventDefault();

    // Gather user data from states
    const userData = {
      name,
    };

    if (profileImage) {
      userData.profileImage = profileImage;
    }

    if (orientation) {
      userData.orientation = orientation;
    }

    if (nickname) {
      userData.nickname = nickname;
    }

    const formData = new FormData();
    const userFormData = Object.keys(userData).forEach((key) =>
      formData.append(key, userData[key])
    );

    formData.append("user", userFormData);
    
    await dispatch(updateProfile(formData));

    setTimeout(() => {
      dispatch(resetMessage());
    }, 2000);
  };


  const handleFile = (e) => {
    const image = e.target.files[0];
    setPreviewImage(image);
    setProfileImage(image);
  }

  return (
    <div className="min-h-dvh px-6 pt-10 pb-8 sm:mx-auto sm:max-w-lg sm:rounded-lg content-center">
      <motion.form
        className="bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-center border-solid shadow-md rounded px-8 pt-6 pb-8 mb-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        onSubmit={handleSubmit}
      >
      <Title2 tit={"Editar meu perfil"} />
      <div className="justify-items-center content-center">
        {(profileImage || previewImage) && (
          <img className="rounded-full w-40 h-40" src={
            previewImage
              ? URL.createObjectURL(previewImage)
              : `${uploads}/users/${user.profileImage}`
          } alt={name} />
        )}
      </div>
        <div className="mb-4 text-left">
          <label className="font-special block mb-2 text-sm font-bold text-gray-900 dark:text-white text-left"></label>
          <input name="profileImage" onChange={handleFile} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" type="file"/>
        </div>
        <div className="mb-4  text-left">
          <label className="font-special block mb-2 text-sm font-bold text-gray-900 dark:text-white text-left">
            Nome
          </label>
          <input name="name" onChange={(e) => setName(e.target.value)} value={name || ""} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" type="text" placeholder="jogador nº 1" />
        </div>
        <div className="mb-4 text-left">
          <label className="font-special block mb-2 text-sm font-bold text-gray-900 dark:text-white text-left">
            Apelido
          </label>
          <input name="nickname" onChange={(e) => setNickname(e.target.value)} value={nickname || ""} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5" type="text" placeholder="minime" />
        </div>
        <div className="mb-5 text-left">
          <label className="font-special block mb-2 text-sm font-bold text-gray-900 dark:text-white text-left">Escolha uma opção</label>
          <select name="orientation" onChange={(e) => setOrientation(e.target.value)} value={orientation || ""} className="text-xl font-special bg-dour-suave border border-dour-suave text-bordo-700 text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl block w-full p-2.5" required>
            <option>Escolha a orientação do seu personagem</option>
            <option value="F">Feminino</option>
            <option value="M">Masculino</option>
          </select>
        </div>
        <div className="flex items-center justify-between">
          {!loading && <input onClick={toggleVisibility} type="submit" className="font-special font-semibold  transition ease-in-out delay-150 duration-300 hover:-translate-y-1 hover:scale-110 text-white bg-bordo hover:bg-bordo-600 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-40 px-5 py-2.5 text-center" value="Salvar" />}
          {loading && <Button propertiesButton={{type: "submit", dis: "disabled", desc: "Aguarde..."}}/>}
          <Links linkProp={{pag: "/Progress", dsLink: "Cancelar", type: "D"}} />
        </div>
        {error && <Message msg={message} type="error" />}
        {message && <Message msg={message} type="success" />}
        </motion.form>
    </div>
  );
}

export default EditProfile;